/* Toont de vaste koopbalk zodra de echte koopknop uit beeld is.

   Werkt met een IntersectionObserver op de knop zelf en niet op een
   scrollpositie: de koopkolom is sticky en verschuift, dus een vaste
   pixelgrens klopt op de ene pagina wel en op de andere niet. */

class OnvelaStickyBuy extends HTMLElement {
  connectedCallback() {
    const formId = this.querySelector('[form]')?.getAttribute('form');
    const echteKnop = formId
      ? document.querySelector(`#${CSS.escape(formId)} [name="add"]`)
      : null;

    if (!echteKnop || !('IntersectionObserver' in window)) return;

    this.hidden = false;

    this.observer = new IntersectionObserver(
      ([entry]) => {
        // Ook verbergen als de knop bóven het scherm ligt maar de pagina nog
        // niet ver genoeg gescrold is; anders flitst de balk bij het laden.
        const uitBeeld = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.classList.toggle('onvela-sticky--in', uitBeeld);
      },
      { rootMargin: '0px 0px -40px 0px' },
    );

    this.observer.observe(echteKnop);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('onvela-sticky-buy')) {
  customElements.define('onvela-sticky-buy', OnvelaStickyBuy);
}
